module.exports = __webpack_public_path__ + "img/repair_closed_red.16768467.svg";